import styled from 'styled-components';
import { fontFamilySize, px } from '../../../../contrib/ui';

export const EventContentStyled = styled.div`
  height: ${px(220)};
  width: 100%;
  position: relative;
  border-radius: ${px(5)};
  overflow: hidden;
  margin-bottom: ${px(15)};

  background-size: cover;
  background-repeat: no-repeat;
  background-position: 50%;

  .bg-wrapper {
    position: absolute;
    overflow: hidden;
    width: 100%;
    height: 100%;
    z-index: 1;
    background-position: 50%;
    background-repeat: no-repeat;
    background-size: cover;

    top: 0;
    left: 0;

    .bg-mask2 {
      z-index: 0;
      position: absolute;
      top: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(0, rgba(0, 0, 0, 0.5) 30%, rgba(256, 256, 256, 0) 110%);
    }
  }

  .event-metadata {
    z-index: 2;
    color: white;
    position: absolute;
    width: 100%;
    padding: ${px(14)};

    img {
      height: ${px(64)};
      width: ${px(64)};
      border-radius: ${px(64)};
    }

    .event-player-status {
      position: absolute;
      top: ${px(14)};
      right: ${px(14)};
      padding: ${px(5)} ${px(15)};
      color: white;
      border-radius: ${px(5)};

      span {
        ${fontFamilySize('Bold', 14)};
      }

      &.in {
        background-color: #6ce1c1;
      }
      &.out {
        background-color: #ff9602;
      }
      &.tbd {
        background-color: var(--grey8e);
      }
    }

    p {
      margin: 0;
      margin-top: ${px(15)};
      line-height: ${px(10)};

      &.event-date,
      &.title,
      &.info {
        text-transform: uppercase;
      }

      &.event-date,
      &.location {
        ${fontFamilySize('Medium', 16)};
      }

      &.title {
        ${fontFamilySize('Heavy', 16)};
        line-height: 1;
      }

      &.info {
        ${fontFamilySize('Bold', 16)};
      }
    }
  }
`;
